// extracted by mini-css-extract-plugin
module.exports = {"content":"styles-module--content--1mOKa"};